// extracted by mini-css-extract-plugin
export var active = "_dj-2";
export var recordingDot = "_dj-1";
export var recordingIndicator = "_dj-0";